export default "__VITE_ASSET__BMSEjGj2__"